import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  OnDestroy
} from "@angular/core";
import {
  NgbModal,
  ModalDismissReasons,
  NgbActiveModal
} from "@ng-bootstrap/ng-bootstrap";
@Component({
  selector: "app-manage-payers-list-modal",
  templateUrl: "./manage-payers-list-modal.component.html",
  styleUrls: ["./manage-payers-list-modal.component.scss"]
})
export class ManagePayersListModalComponent implements OnInit, OnDestroy {
  //total: any = 0;
  @Input() currentSelectedPayer;
  @Input() availableList;
  @Input() total;
  @Output("on-save") save = new EventEmitter<any>();
  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit() {}
  ngOnDestroy() {
    this.save.unsubscribe();
    this.save = null;
  }

  onSubmit() {
    //var ids = this.getIdsOfSelectedTickets();
    var totalInteger = parseInt(this.total);
    this.save.emit(totalInteger);
  }

  getIdsOfSelectedTickets() {
    var tickets: any = [];
    $.each($(".ticket-checkbox:checked"), function() {
      let value: any = $(this).val();
      tickets.push(parseInt(value));
    });
    return tickets;
  }

  recalculateTotal() {
    var ids = this.getIdsOfSelectedTickets();
    var total = 0;
    for (var i = 0; i < ids.length; i++) {
      for (var j = 0; j < this.availableList.length; j++) {
        if (ids[i] == this.availableList[j].id) {
          total += this.availableList[j].ticketPrice;
        }
      }
    }
    this.total = total;
  }
}
